import { date } from 'quasar'
import Membership from 'src/models/membership/Membership'
import Model, { encoders, ID, Integer, IsoDate } from 'src/models/model'

export default class MembershipInterval extends Model {
  static name = 'MembershipInterval'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      state: {
        type: String,
        output: true
      },
      membership: {
        type: Membership,
        encode: encoders.hasOne,
        reference: true
      },
      amount: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: 0
      },
      term: {
        type: Integer,
        output: true
      },
      startDate: {
        type: IsoDate,
        default: null,
        output: true
      },
      endDate: {
        type: IsoDate,
        default: null,
        output: true
      }
    }

    this.computed = {
      current () {
        if (this.state !== 'valid') return

        const today = new Date()
        return this.startDate <= today && this.endDate >= today
      },
      renewalDate () {
        return new IsoDate(date.addToDate(this.endDate, { date: 1 }))
      }
    }
  }
}
